export default () => ({
  show: false,
  isLoading: true,
  onCancel: false,
  fullPage: true,
  seeUploadImage: false,
  img_url: null,
  book_occurrence: {
    book: null
  },
  max: 500,
  occurrence: {
    content: null,
    image_id: null,
    img: null,
    image: []
  },
  occurrences: [],
  entity: 'occurrence',
  entities: 'occurrences',
  prefixRouter: 'tenant.book.occurrence'
})



// WEBPACK FOOTER //
// ./src/app/tenant/book-occurrence/resources/data.js